export default __webpack_public_path__ + "static/media/Ivory Chill.876665a4.otf";